function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 11.295a1.794 1.794 0 110 3.588 1.794 1.794 0 010-3.588zM4.322 8.693A5.203 5.203 0 019.71 7.465c.74.254 1.411.673 1.965 1.225a.897.897 0 01-.634 1.531l-.117-.007a.895.895 0 01-.515-.254l-.067-.055-.069-.056a3.408 3.408 0 00-4.683.111.894.894 0 01-.634.264l-.12-.008a.898.898 0 01-.514-1.523zM2.293 5.947a8.081 8.081 0 0111.412 0 .89.89 0 01.262.633v.021a.89.89 0 01-.893.876l-.118-.008a.892.892 0 01-.516-.254 6.286 6.286 0 00-8.878 0 .898.898 0 01-1.268-1.268zM.263 3.2c4.276-4.267 11.198-4.267 15.474 0a.894.894 0 01-.402 1.5.894.894 0 01-.866-.232 9.162 9.162 0 00-12.939 0A.897.897 0 01.262 3.2z"
});

function SvgHappyWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15"
  }, props), _ref);
}

export default SvgHappyWifi;